import { merge } from 'lodash';

import Boolean from 'hb-react/shared/components/formik/components/inputs/Boolean';
import Date from 'hb-react/shared/components/formik/components/inputs/Date';
import DoubleSelect from 'hb-react/shared/components/formik/components/inputs/DoubleSelect';
import Number from 'hb-react/shared/components/formik/components/inputs/Number';
import SelectArray from 'hb-react/shared/components/formik/components/inputs/SelectArray';
import Text from 'hb-react/shared/components/formik/components/inputs/Text';

const defaultPropsMapper = (customAttribute) => ({
  label: customAttribute.display_name,
  placeholder: customAttribute.placeholder,
  tooltip: customAttribute.tooltip,
  validate: {
    required: customAttribute.required,
  },
  info: customAttribute.info,
});

const mapping = {
  boolean: {
    component: Boolean,
    propsMapper: (_customAttribute) => ({}),
  },
  date: {
    component: Date,
    propsMapper: (_customAttribute) => ({}),
  },
  decimal: {
    component: Number,
    propsMapper: (_customAttribute) => ({}),
  },
  double_select: {
    component: DoubleSelect,
    propsMapper: ({ json_options: { options, child_label: childLabel } }) => ({
      options,
      childLabel,
      isClearable: true,
    }),
  },
  select: {
    component: SelectArray,
    propsMapper: ({
      multi,
      options,
      paginated_options: paginatedOptions = false,
      id,
    }) => {
      const props = {
        options,
        multiple: multi,
        isClearable: true,
      };

      /**
       * We check if the backend sends the 'paginated_options' property.
       * If it is true then we must add the specific type 'customizable_attribute_select_async' and
       * add the property 'customizableAttributeId' that has the id of a customizable attribute.
       */
      if (paginatedOptions) {
        props.type = 'customizable_attribute_select_async';
        props.customizableAttributeId = id;
      }

      return props;
    },
  },
  text: {
    component: Text,
    propsMapper: ({ text_size: textSize }) => ({
      validate: {
        maxLength: textSize || 255,
      },
    }),
  },
};

export default (customAttribute) => ({
  component: mapCustomAttributeToComponent(customAttribute),
  props: mapCustomAttributeToProps(customAttribute),
});

const mapCustomAttributeToComponent = (customAttribute) => {
  const { component } = getMapping(customAttribute);

  return component;
};

const mapCustomAttributeToProps = (customAttribute) => {
  const { propsMapper } = getMapping(customAttribute);

  return merge(
    {},
    defaultPropsMapper(customAttribute),
    propsMapper(customAttribute),
  );
};

class UnkownCustomAttributeError extends Error {}

const getMapping = ({ attribute_type: attributeType }) => {
  const result = mapping[attributeType];

  if (!result || !result.component || !result.propsMapper) {
    throw new UnkownCustomAttributeError(
      `Custom attribute with type "${attributeType}" does not exist`,
    );
  }

  return result;
};
